import { RootState } from '../../store';
import { createSelector } from 'reselect';

const selectGraphMinimapVisibilityState=  (state: RootState) => state.graphMinimapVisibility;

export const selectMinimapVisibility = createSelector(
    selectGraphMinimapVisibilityState,
    (graphMinimapVisibility) => graphMinimapVisibility.visible,
);